// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: 24qDGfvb2rMn6oy8PVF95d
// Component: UrZe_-WaO3P

import * as React from "react";

import * as p from "@plasmicapp/react-web";
import * as ph from "@plasmicapp/react-web/lib/host";

import {
  hasVariant,
  classNames,
  wrapWithClassName,
  createPlasmicElementProxy,
  makeFragment,
  MultiChoiceArg,
  SingleBooleanChoiceArg,
  SingleChoiceArg,
  pick,
  omit,
  useTrigger,
  StrictProps,
  deriveRenderOpts,
  ensureGlobalVariants
} from "@plasmicapp/react-web";
import CircleAddButton from "../../CircleAddButton"; // plasmic-import: ZfrYJ616sV/component

import "@plasmicapp/react-web/lib/plasmic.css";

import plasmic_antd_5_hostless_css from "../antd_5_hostless/plasmic_antd_5_hostless.module.css"; // plasmic-import: ohDidvG9XsCeFumugENU3J/projectcss
import plasmic_plasmic_rich_components_css from "../plasmic_rich_components/plasmic_plasmic_rich_components.module.css"; // plasmic-import: jkU633o1Cz7HrJdwdxhVHk/projectcss
import plasmic_pro_pro_css from "../pro_pro/plasmic_pro_pro.module.css"; // plasmic-import: qtWvXH8Uhh67sc1TY2MZeK/projectcss
import projectcss from "./plasmic_hub_hub.module.css"; // plasmic-import: 24qDGfvb2rMn6oy8PVF95d/projectcss
import sty from "./PlasmicInterestTile.module.css"; // plasmic-import: UrZe_-WaO3P/css

createPlasmicElementProxy;

export type PlasmicInterestTile__VariantMembers = {
  selected: "selected";
  sectionSettings: "sectionSettings";
  sectionSettingsSquashed: "sectionSettingsSquashed";
  interest:
    | "personalImprovement"
    | "productivity"
    | "videoGames"
    | "nature"
    | "art"
    | "science"
    | "fitness"
    | "photography"
    | "health"
    | "entrepreneurship"
    | "designUx"
    | "programming"
    | "future"
    | "technology"
    | "comedy";
  variant:
    | "_default"
    | "selected"
    | "sectionSettings"
    | "sectionSettingsSquashed";
};
export type PlasmicInterestTile__VariantsArgs = {
  selected?: SingleBooleanChoiceArg<"selected">;
  sectionSettings?: SingleBooleanChoiceArg<"sectionSettings">;
  sectionSettingsSquashed?: SingleBooleanChoiceArg<"sectionSettingsSquashed">;
  interest?: SingleChoiceArg<
    | "personalImprovement"
    | "productivity"
    | "videoGames"
    | "nature"
    | "art"
    | "science"
    | "fitness"
    | "photography"
    | "health"
    | "entrepreneurship"
    | "designUx"
    | "programming"
    | "future"
    | "technology"
    | "comedy"
  >;
  variant?: SingleChoiceArg<
    "_default" | "selected" | "sectionSettings" | "sectionSettingsSquashed"
  >;
};
type VariantPropType = keyof PlasmicInterestTile__VariantsArgs;
export const PlasmicInterestTile__VariantProps = new Array<VariantPropType>(
  "selected",
  "sectionSettings",
  "sectionSettingsSquashed",
  "interest",
  "variant"
);

export type PlasmicInterestTile__ArgsType = {
  name?: string;
};
type ArgPropType = keyof PlasmicInterestTile__ArgsType;
export const PlasmicInterestTile__ArgProps = new Array<ArgPropType>("name");

export type PlasmicInterestTile__OverridesType = {
  root?: p.Flex<"button">;
  bgImage?: p.Flex<typeof p.PlasmicImg>;
  interestBox?: p.Flex<"div">;
  text?: p.Flex<"div">;
  addButton?: p.Flex<typeof CircleAddButton>;
};

export interface DefaultInterestTileProps {
  name?: string;
  selected?: SingleBooleanChoiceArg<"selected">;
  sectionSettings?: SingleBooleanChoiceArg<"sectionSettings">;
  sectionSettingsSquashed?: SingleBooleanChoiceArg<"sectionSettingsSquashed">;
  interest?: SingleChoiceArg<
    | "personalImprovement"
    | "productivity"
    | "videoGames"
    | "nature"
    | "art"
    | "science"
    | "fitness"
    | "photography"
    | "health"
    | "entrepreneurship"
    | "designUx"
    | "programming"
    | "future"
    | "technology"
    | "comedy"
  >;
  variant?: SingleChoiceArg<
    "_default" | "selected" | "sectionSettings" | "sectionSettingsSquashed"
  >;
  className?: string;
}

const $$ = {};

function PlasmicInterestTile__RenderFunc(props: {
  variants: PlasmicInterestTile__VariantsArgs;
  args: PlasmicInterestTile__ArgsType;
  overrides: PlasmicInterestTile__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const args = React.useMemo(
    () =>
      Object.assign(
        {
          name: "Personal Improvement"
        },
        props.args
      ),
    [props.args]
  );

  const $props = {
    ...args,
    ...variants
  };

  const $ctx = ph.useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const currentUser = p.useCurrentUser?.() || {};

  const stateSpecs: Parameters<typeof p.useDollarState>[0] = React.useMemo(
    () => [
      {
        path: "selected",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $ctx }) => $props.selected
      },
      {
        path: "sectionSettings",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $ctx }) => $props.sectionSettings
      },
      {
        path: "sectionSettingsSquashed",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $ctx }) =>
          $props.sectionSettingsSquashed
      },
      {
        path: "interest",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $ctx }) => $props.interest
      },
      {
        path: "variant",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $ctx }) => $props.variant
      }
    ],
    [$props, $ctx, $refs]
  );
  const $state = p.useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $refs
  });

  return (
    <button
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        projectcss.all,
        projectcss.button,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        projectcss.plasmic_tokens,
        plasmic_antd_5_hostless_css.plasmic_tokens,
        plasmic_plasmic_rich_components_css.plasmic_tokens,
        plasmic_pro_pro_css.plasmic_tokens,
        sty.root,
        {
          [sty.rootinterest_personalImprovement]: hasVariant(
            $state,
            "interest",
            "personalImprovement"
          ),
          [sty.rootsectionSettingsSquashed]: hasVariant(
            $state,
            "sectionSettingsSquashed",
            "sectionSettingsSquashed"
          ),
          [sty.rootsectionSettings]: hasVariant(
            $state,
            "sectionSettings",
            "sectionSettings"
          ),
          [sty.rootselected]: hasVariant($state, "selected", "selected"),
          [sty.rootvariant_sectionSettingsSquashed]: hasVariant(
            $state,
            "variant",
            "sectionSettingsSquashed"
          ),
          [sty.rootvariant_sectionSettings]: hasVariant(
            $state,
            "variant",
            "sectionSettings"
          ),
          [sty.rootvariant_selected]: hasVariant($state, "variant", "selected")
        }
      )}
    >
      <div
        className={classNames(projectcss.all, sty.freeBox___0CBgA, {
          [sty.freeBoxinterest_art___0CBgARgWmC]: hasVariant(
            $state,
            "interest",
            "art"
          ),
          [sty.freeBoxinterest_comedy___0CBgAci3Lx]: hasVariant(
            $state,
            "interest",
            "comedy"
          ),
          [sty.freeBoxinterest_designUx___0CBgAGvnx5]: hasVariant(
            $state,
            "interest",
            "designUx"
          ),
          [sty.freeBoxinterest_entrepreneurship___0CBgAhA5D]: hasVariant(
            $state,
            "interest",
            "entrepreneurship"
          ),
          [sty.freeBoxinterest_fitness___0CBgA7CwRb]: hasVariant(
            $state,
            "interest",
            "fitness"
          ),
          [sty.freeBoxinterest_future___0CBgAxTkQ]: hasVariant(
            $state,
            "interest",
            "future"
          ),
          [sty.freeBoxinterest_health___0CBgAneAp]: hasVariant(
            $state,
            "interest",
            "health"
          ),
          [sty.freeBoxinterest_nature___0CBgA6CLqR]: hasVariant(
            $state,
            "interest",
            "nature"
          ),
          [sty.freeBoxinterest_personalImprovement___0CBgAukZ0R]: hasVariant(
            $state,
            "interest",
            "personalImprovement"
          ),
          [sty.freeBoxinterest_photography___0CBgAsWw7K]: hasVariant(
            $state,
            "interest",
            "photography"
          ),
          [sty.freeBoxinterest_productivity___0CBgAHwlW2]: hasVariant(
            $state,
            "interest",
            "productivity"
          ),
          [sty.freeBoxinterest_programming___0CBgAnIpkR]: hasVariant(
            $state,
            "interest",
            "programming"
          ),
          [sty.freeBoxinterest_science___0CBgAk9Erv]: hasVariant(
            $state,
            "interest",
            "science"
          ),
          [sty.freeBoxinterest_technology___0CBgA5QzhF]: hasVariant(
            $state,
            "interest",
            "technology"
          ),
          [sty.freeBoxinterest_videoGames___0CBgA6Df1C]: hasVariant(
            $state,
            "interest",
            "videoGames"
          ),
          [sty.freeBoxsectionSettingsSquashed___0CBgA1FXWk]: hasVariant(
            $state,
            "sectionSettingsSquashed",
            "sectionSettingsSquashed"
          ),
          [sty.freeBoxsectionSettings___0CBgADqL73]: hasVariant(
            $state,
            "sectionSettings",
            "sectionSettings"
          ),
          [sty.freeBoxselected___0CBgAk7FwP]: hasVariant(
            $state,
            "selected",
            "selected"
          ),
          [sty.freeBoxvariant__default___0CBgAimD7]: hasVariant(
            $state,
            "variant",
            "_default"
          ),
          [sty.freeBoxvariant_sectionSettingsSquashed___0CBgA6VEbi]: hasVariant(
            $state,
            "variant",
            "sectionSettingsSquashed"
          ),
          [sty.freeBoxvariant_sectionSettings___0CBgAxyKiJ]: hasVariant(
            $state,
            "variant",
            "sectionSettings"
          ),
          [sty.freeBoxvariant_selected___0CBgAjNaXi]: hasVariant(
            $state,
            "variant",
            "selected"
          )
        })}
      >
        <p.PlasmicImg
          data-plasmic-name={"bgImage"}
          data-plasmic-override={overrides.bgImage}
          alt={""}
          className={classNames(sty.bgImage, {
            [sty.bgImageinterest_comedy]: hasVariant(
              $state,
              "interest",
              "comedy"
            ),
            [sty.bgImageinterest_personalImprovement]: hasVariant(
              $state,
              "interest",
              "personalImprovement"
            ),
            [sty.bgImagesectionSettingsSquashed]: hasVariant(
              $state,
              "sectionSettingsSquashed",
              "sectionSettingsSquashed"
            ),
            [sty.bgImagesectionSettings]: hasVariant(
              $state,
              "sectionSettings",
              "sectionSettings"
            ),
            [sty.bgImageselected]: hasVariant($state, "selected", "selected")
          })}
          displayHeight={"100%"}
          displayMaxHeight={"none"}
          displayMaxWidth={"100%"}
          displayMinHeight={"0"}
          displayMinWidth={"0"}
          displayWidth={
            hasVariant($state, "sectionSettings", "sectionSettings")
              ? "100%"
              : "100%"
          }
          loader={"plasmic"}
          loading={"lazy"}
          src={{
            src: "https://img.plasmic.app/img-optimizer/v1/img/60ef2be5e49281901ec7430e61308ca0.jpg",
            fullWidth: 422,
            fullHeight: 281
          }}
        />

        <div
          data-plasmic-name={"interestBox"}
          data-plasmic-override={overrides.interestBox}
          className={classNames(projectcss.all, sty.interestBox, {
            [sty.interestBoxinterest_art]: hasVariant(
              $state,
              "interest",
              "art"
            ),
            [sty.interestBoxinterest_comedy]: hasVariant(
              $state,
              "interest",
              "comedy"
            ),
            [sty.interestBoxinterest_designUx]: hasVariant(
              $state,
              "interest",
              "designUx"
            ),
            [sty.interestBoxinterest_entrepreneurship]: hasVariant(
              $state,
              "interest",
              "entrepreneurship"
            ),
            [sty.interestBoxinterest_fitness]: hasVariant(
              $state,
              "interest",
              "fitness"
            ),
            [sty.interestBoxinterest_future]: hasVariant(
              $state,
              "interest",
              "future"
            ),
            [sty.interestBoxinterest_health]: hasVariant(
              $state,
              "interest",
              "health"
            ),
            [sty.interestBoxinterest_nature]: hasVariant(
              $state,
              "interest",
              "nature"
            ),
            [sty.interestBoxinterest_personalImprovement]: hasVariant(
              $state,
              "interest",
              "personalImprovement"
            ),
            [sty.interestBoxinterest_photography]: hasVariant(
              $state,
              "interest",
              "photography"
            ),
            [sty.interestBoxinterest_productivity]: hasVariant(
              $state,
              "interest",
              "productivity"
            ),
            [sty.interestBoxinterest_programming]: hasVariant(
              $state,
              "interest",
              "programming"
            ),
            [sty.interestBoxinterest_science]: hasVariant(
              $state,
              "interest",
              "science"
            ),
            [sty.interestBoxinterest_technology]: hasVariant(
              $state,
              "interest",
              "technology"
            ),
            [sty.interestBoxinterest_videoGames]: hasVariant(
              $state,
              "interest",
              "videoGames"
            ),
            [sty.interestBoxsectionSettingsSquashed]: hasVariant(
              $state,
              "sectionSettingsSquashed",
              "sectionSettingsSquashed"
            ),
            [sty.interestBoxsectionSettings]: hasVariant(
              $state,
              "sectionSettings",
              "sectionSettings"
            ),
            [sty.interestBoxselected]: hasVariant(
              $state,
              "selected",
              "selected"
            ),
            [sty.interestBoxvariant__default]: hasVariant(
              $state,
              "variant",
              "_default"
            ),
            [sty.interestBoxvariant_sectionSettingsSquashed]: hasVariant(
              $state,
              "variant",
              "sectionSettingsSquashed"
            ),
            [sty.interestBoxvariant_sectionSettings]: hasVariant(
              $state,
              "variant",
              "sectionSettings"
            ),
            [sty.interestBoxvariant_selected]: hasVariant(
              $state,
              "variant",
              "selected"
            )
          })}
        >
          <div
            className={classNames(projectcss.all, sty.freeBox__obCa, {
              [sty.freeBoxinterest_art__obCaRgWmC]: hasVariant(
                $state,
                "interest",
                "art"
              ),
              [sty.freeBoxinterest_comedy__obCaci3Lx]: hasVariant(
                $state,
                "interest",
                "comedy"
              ),
              [sty.freeBoxinterest_designUx__obCaGvnx5]: hasVariant(
                $state,
                "interest",
                "designUx"
              ),
              [sty.freeBoxinterest_entrepreneurship__obCahA5D]: hasVariant(
                $state,
                "interest",
                "entrepreneurship"
              ),
              [sty.freeBoxinterest_fitness__obCa7CwRb]: hasVariant(
                $state,
                "interest",
                "fitness"
              ),
              [sty.freeBoxinterest_future__obCaxTkQ]: hasVariant(
                $state,
                "interest",
                "future"
              ),
              [sty.freeBoxinterest_health__obCaNeAp]: hasVariant(
                $state,
                "interest",
                "health"
              ),
              [sty.freeBoxinterest_nature__obCa6CLqR]: hasVariant(
                $state,
                "interest",
                "nature"
              ),
              [sty.freeBoxinterest_personalImprovement__obCaukZ0R]: hasVariant(
                $state,
                "interest",
                "personalImprovement"
              ),
              [sty.freeBoxinterest_photography__obCaSWw7K]: hasVariant(
                $state,
                "interest",
                "photography"
              ),
              [sty.freeBoxinterest_productivity__obCaHwlW2]: hasVariant(
                $state,
                "interest",
                "productivity"
              ),
              [sty.freeBoxinterest_programming__obCaNIpkR]: hasVariant(
                $state,
                "interest",
                "programming"
              ),
              [sty.freeBoxinterest_science__obCak9Erv]: hasVariant(
                $state,
                "interest",
                "science"
              ),
              [sty.freeBoxinterest_technology__obCa5QzhF]: hasVariant(
                $state,
                "interest",
                "technology"
              ),
              [sty.freeBoxinterest_videoGames__obCa6Df1C]: hasVariant(
                $state,
                "interest",
                "videoGames"
              ),
              [sty.freeBoxsectionSettingsSquashed__obCa1FXWk]: hasVariant(
                $state,
                "sectionSettingsSquashed",
                "sectionSettingsSquashed"
              ),
              [sty.freeBoxsectionSettings__obCaDqL73]: hasVariant(
                $state,
                "sectionSettings",
                "sectionSettings"
              ),
              [sty.freeBoxselected__obCak7FwP]: hasVariant(
                $state,
                "selected",
                "selected"
              ),
              [sty.freeBoxvariant_sectionSettingsSquashed__obCa6VEbi]:
                hasVariant($state, "variant", "sectionSettingsSquashed"),
              [sty.freeBoxvariant_sectionSettings__obCaxyKiJ]: hasVariant(
                $state,
                "variant",
                "sectionSettings"
              ),
              [sty.freeBoxvariant_selected__obCajNaXi]: hasVariant(
                $state,
                "variant",
                "selected"
              )
            })}
          >
            <div
              data-plasmic-name={"text"}
              data-plasmic-override={overrides.text}
              className={classNames(
                projectcss.all,
                projectcss.__wab_text,
                sty.text,
                {
                  [sty.textinterest_art]: hasVariant($state, "interest", "art"),
                  [sty.textinterest_comedy]: hasVariant(
                    $state,
                    "interest",
                    "comedy"
                  ),
                  [sty.textinterest_designUx]: hasVariant(
                    $state,
                    "interest",
                    "designUx"
                  ),
                  [sty.textinterest_entrepreneurship]: hasVariant(
                    $state,
                    "interest",
                    "entrepreneurship"
                  ),
                  [sty.textinterest_fitness]: hasVariant(
                    $state,
                    "interest",
                    "fitness"
                  ),
                  [sty.textinterest_future]: hasVariant(
                    $state,
                    "interest",
                    "future"
                  ),
                  [sty.textinterest_health]: hasVariant(
                    $state,
                    "interest",
                    "health"
                  ),
                  [sty.textinterest_nature]: hasVariant(
                    $state,
                    "interest",
                    "nature"
                  ),
                  [sty.textinterest_personalImprovement]: hasVariant(
                    $state,
                    "interest",
                    "personalImprovement"
                  ),
                  [sty.textinterest_photography]: hasVariant(
                    $state,
                    "interest",
                    "photography"
                  ),
                  [sty.textinterest_productivity]: hasVariant(
                    $state,
                    "interest",
                    "productivity"
                  ),
                  [sty.textinterest_programming]: hasVariant(
                    $state,
                    "interest",
                    "programming"
                  ),
                  [sty.textinterest_science]: hasVariant(
                    $state,
                    "interest",
                    "science"
                  ),
                  [sty.textinterest_technology]: hasVariant(
                    $state,
                    "interest",
                    "technology"
                  ),
                  [sty.textinterest_videoGames]: hasVariant(
                    $state,
                    "interest",
                    "videoGames"
                  ),
                  [sty.textsectionSettingsSquashed]: hasVariant(
                    $state,
                    "sectionSettingsSquashed",
                    "sectionSettingsSquashed"
                  ),
                  [sty.textsectionSettings]: hasVariant(
                    $state,
                    "sectionSettings",
                    "sectionSettings"
                  ),
                  [sty.textvariant_sectionSettingsSquashed]: hasVariant(
                    $state,
                    "variant",
                    "sectionSettingsSquashed"
                  ),
                  [sty.textvariant_sectionSettings]: hasVariant(
                    $state,
                    "variant",
                    "sectionSettings"
                  )
                }
              )}
            >
              {hasVariant($state, "interest", "comedy") ? (
                "Comedy"
              ) : hasVariant($state, "interest", "technology") ? (
                "Technology"
              ) : hasVariant($state, "interest", "future") ? (
                "Future"
              ) : hasVariant($state, "interest", "programming") ? (
                "Programming"
              ) : hasVariant($state, "interest", "designUx") ? (
                "Design & UX"
              ) : hasVariant($state, "interest", "entrepreneurship") ? (
                "Entrepreneurship"
              ) : hasVariant($state, "interest", "health") ? (
                "Health"
              ) : hasVariant($state, "interest", "photography") ? (
                "Photography"
              ) : hasVariant($state, "interest", "fitness") ? (
                "Fitness"
              ) : hasVariant($state, "interest", "science") ? (
                "Science"
              ) : hasVariant($state, "interest", "art") ? (
                "Art"
              ) : hasVariant($state, "interest", "nature") ? (
                "Nature"
              ) : hasVariant($state, "interest", "videoGames") ? (
                "Video Games"
              ) : hasVariant($state, "interest", "productivity") ? (
                "Productivity"
              ) : hasVariant($state, "interest", "personalImprovement") ? (
                "Personal Improvement"
              ) : (
                <React.Fragment>
                  {(() => {
                    try {
                      return $props.name;
                    } catch (e) {
                      if (
                        e instanceof TypeError ||
                        e?.plasmicType === "PlasmicUndefinedDataError"
                      ) {
                        return "Interest Name";
                      }
                      throw e;
                    }
                  })()}
                </React.Fragment>
              )}
            </div>
          </div>
          <CircleAddButton
            data-plasmic-name={"addButton"}
            data-plasmic-override={overrides.addButton}
            className={classNames("__wab_instance", sty.addButton, {
              [sty.addButtoninterest_art]: hasVariant(
                $state,
                "interest",
                "art"
              ),
              [sty.addButtoninterest_comedy]: hasVariant(
                $state,
                "interest",
                "comedy"
              ),
              [sty.addButtoninterest_designUx]: hasVariant(
                $state,
                "interest",
                "designUx"
              ),
              [sty.addButtoninterest_entrepreneurship]: hasVariant(
                $state,
                "interest",
                "entrepreneurship"
              ),
              [sty.addButtoninterest_fitness]: hasVariant(
                $state,
                "interest",
                "fitness"
              ),
              [sty.addButtoninterest_future]: hasVariant(
                $state,
                "interest",
                "future"
              ),
              [sty.addButtoninterest_health]: hasVariant(
                $state,
                "interest",
                "health"
              ),
              [sty.addButtoninterest_nature]: hasVariant(
                $state,
                "interest",
                "nature"
              ),
              [sty.addButtoninterest_personalImprovement]: hasVariant(
                $state,
                "interest",
                "personalImprovement"
              ),
              [sty.addButtoninterest_photography]: hasVariant(
                $state,
                "interest",
                "photography"
              ),
              [sty.addButtoninterest_productivity]: hasVariant(
                $state,
                "interest",
                "productivity"
              ),
              [sty.addButtoninterest_programming]: hasVariant(
                $state,
                "interest",
                "programming"
              ),
              [sty.addButtoninterest_science]: hasVariant(
                $state,
                "interest",
                "science"
              ),
              [sty.addButtoninterest_technology]: hasVariant(
                $state,
                "interest",
                "technology"
              ),
              [sty.addButtoninterest_videoGames]: hasVariant(
                $state,
                "interest",
                "videoGames"
              ),
              [sty.addButtonsectionSettingsSquashed]: hasVariant(
                $state,
                "sectionSettingsSquashed",
                "sectionSettingsSquashed"
              ),
              [sty.addButtonsectionSettings]: hasVariant(
                $state,
                "sectionSettings",
                "sectionSettings"
              ),
              [sty.addButtonselected]: hasVariant(
                $state,
                "selected",
                "selected"
              ),
              [sty.addButtonvariant__default]: hasVariant(
                $state,
                "variant",
                "_default"
              ),
              [sty.addButtonvariant_sectionSettingsSquashed]: hasVariant(
                $state,
                "variant",
                "sectionSettingsSquashed"
              ),
              [sty.addButtonvariant_sectionSettings]: hasVariant(
                $state,
                "variant",
                "sectionSettings"
              ),
              [sty.addButtonvariant_selected]: hasVariant(
                $state,
                "variant",
                "selected"
              )
            })}
            state={
              hasVariant($state, "variant", "selected")
                ? "selected"
                : hasVariant($state, "selected", "selected")
                ? "selected"
                : "unselected"
            }
          />
        </div>
      </div>
    </button>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  root: ["root", "bgImage", "interestBox", "text", "addButton"],
  bgImage: ["bgImage"],
  interestBox: ["interestBox", "text", "addButton"],
  text: ["text"],
  addButton: ["addButton"]
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  root: "button";
  bgImage: typeof p.PlasmicImg;
  interestBox: "div";
  text: "div";
  addButton: typeof CircleAddButton;
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicInterestTile__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicInterestTile__VariantsArgs;
    args?: PlasmicInterestTile__ArgsType;
    overrides?: NodeOverridesType<T>;
  } & Omit<PlasmicInterestTile__VariantsArgs, ReservedPropsType> & // Specify variants directly as props
    /* Specify args directly as props*/ Omit<
      PlasmicInterestTile__ArgsType,
      ReservedPropsType
    > &
    /* Specify overrides for each element directly as props*/ Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    /* Specify props for the root element*/ Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicInterestTile__ArgProps,
          internalVariantPropNames: PlasmicInterestTile__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicInterestTile__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicInterestTile";
  } else {
    func.displayName = `PlasmicInterestTile.${nodeName}`;
  }
  return func;
}

export const PlasmicInterestTile = Object.assign(
  // Top-level PlasmicInterestTile renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    bgImage: makeNodeComponent("bgImage"),
    interestBox: makeNodeComponent("interestBox"),
    text: makeNodeComponent("text"),
    addButton: makeNodeComponent("addButton"),

    // Metadata about props expected for PlasmicInterestTile
    internalVariantProps: PlasmicInterestTile__VariantProps,
    internalArgProps: PlasmicInterestTile__ArgProps
  }
);

export default PlasmicInterestTile;
/* prettier-ignore-end */
